import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import WarehouseOutActions from "../../../../reducers/modules/warehouse/warehouse-out/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "warehouse/warehouse-out";

export default class WarehouseOutMiddleware {
  static create(params) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.create());
      WarehouseOutMiddleware.showHelperFull(dispatch, params);
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.update());
      WarehouseOutMiddleware.showHelperFull(dispatch, params);
      WarehouseOutMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.process());
      WarehouseOutMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(WarehouseOutActions.reset());
    };
  }
  static getPrint(params) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.beforePrint());
      WarehouseOutMiddleware.showPrint(dispatch, params);
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(WarehouseOutActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.view());
      WarehouseOutMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.submit());
      WarehouseOutMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.submit());
      WarehouseOutMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(WarehouseOutActions.delete());
      WarehouseOutMiddleware.delete(dispatch, params, id);
    };
  }
  static beforeCancel(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(WarehouseOutActions.cancel());
      WarehouseOutMiddleware.saveCancel(dispatch, post, search);
    };
  }
  static getToken() {
    return cookieManager.getUserToken();
  }
  static getHelperFull(params = null) {
    return (dispatch) => {
      WarehouseOutMiddleware.showHelperFull(dispatch, params);
    };
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-warehouse-out",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseOutActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error);
      });
  }
  static saveCancel(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: url + "/destroy/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseOutActions.process(),
            WarehouseOutMiddleware.showlist(dispatch, search)
          );
          dispatch(WarehouseOutActions.success());
          WarehouseOutMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Cancel Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseOutActions.print(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error);
      });
  }

  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseOutActions.list(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(WarehouseOutActions.view(response.data.result));
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseOutActions.process(),
            WarehouseOutMiddleware.showlist(dispatch, params)
          );
          WarehouseOutMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseOutActions.process(),
            WarehouseOutMiddleware.showlist(dispatch, search)
          );
          dispatch(WarehouseOutActions.success());
          WarehouseOutMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${WarehouseOutMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            WarehouseOutActions.process(),
            WarehouseOutMiddleware.showlist(dispatch, search)
          );
          dispatch(WarehouseOutActions.success());
          WarehouseOutMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        WarehouseOutMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(WarehouseOutActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
